import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return _withDirectives((_openBlock(), _createBlock(_component_Modal, {
    title: _ctx.title,
    message: _ctx.message,
    image: "ill_hanging_confirmation",
    textSuccess: _ctx.textSuccess,
    textCancel: _ctx.textCancel,
    onClose: _ctx.onClose,
    onSubmit: _ctx.onSubmit,
    isLoading: _ctx.loading
  }, null, 8, ["title", "message", "textSuccess", "textCancel", "onClose", "onSubmit", "isLoading"])), [
    [_vShow, _ctx.visible]
  ])
}